import Loading from '@alifd/next/lib/loading';
export default Loading;